import { Component } from '@angular/core';
import { ConfigService } from '@core/services';
import { AccountService } from '@features/server-side-authentication';
//@ts-ignore
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle';
// @ts-ignore
import SwaggerUIStandalonePreset from 'swagger-ui-dist/swagger-ui-standalone-preset';

@Component({
  selector: 'app-swagger-view',
  standalone: false,
  templateUrl: './swagger-view.component.html',
  styleUrl: './swagger-view.component.scss',
})
export class SwaggerViewComponent {
  constructor(
    private readonly accountService: AccountService,
    private readonly configService: ConfigService,
  ) {}

  ngAfterViewInit() {
    let authToken = `Bearer ${this.accountService.accessToken}`;

    if (this.configService.staticToken) {
      authToken = `Token ${this.configService.staticToken}`;
    }

    SwaggerUIBundle({
      url: '/api/schema/',
      dom_id: '#swaggercontainer',
      presets: [SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset],
      requestInterceptor: (req: any) => {
        if (authToken) {
          req['headers']['Authorization'] = authToken;
        }
        return req;
      },
    });
  }
}
